import styled from "styled-components";

import sun from "../../assets/logos_svg/sun.svg";
import moon from "../../assets/logos_svg/moon.svg";

const Toggler = ({ theme, themeToggler }) => {
  return (
    <StyledToggle onClick={themeToggler}>
      {theme === "light" ? (
        <Icon src={moon} alt="moon" />
      ) : (
        <Icon src={sun} alt="sun" />
      )}
    </StyledToggle>
  );
};

export default Toggler;

const StyledToggle = styled.div`
  display: flex; */
  align-items: center;
  transition: ${({ theme }) => theme.body} var(500ms);
  cursor: pointer;
`;

const Label = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.text};

  &:hover {
    background-color: ${({ theme }) => theme.accent};
  }
`;

const Icon = styled.img`
  width: 32px;
`;
